import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface CandidatePayload {
  full_name: string;
  email: string;
}

export interface InviteCandidatesPayload {
  candidates: CandidatePayload[];
}

/**
 * Hook to invite candidates using React Query mutation
 */
export const useInviteCandidates = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async ({ assessmentId, candidates }: { assessmentId: string; candidates: CandidatePayload[] }) => {
      const response = await apiClient.post(
        `/assessment/invite-candidates/${assessmentId}/`,
        candidates
      );
      return response.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: 'Success',
        text: 'Candidates invited successfully',
        type: 'success',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err?.response?.data?.message || 'Failed to invite candidates';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};